export default __webpack_public_path__ + "static/media/gallery_00.bb9294f6.jpg";